import * as React from 'react';

import GenericError, { IGenericErrorProps } from '../components/common/GenericError';
import layoutWrapper from '../hocs/layoutWrapper';

class ErrorPage extends React.PureComponent<IGenericErrorProps> {
  public render() {
    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            <section>
              <GenericError {...this.props} />
            </section>
          </div>
        </div>
      </div>
    );
  }
}

export default layoutWrapper(ErrorPage, { headerType: 'FULL', footerType: 'MINIMAL' });
